<div class="email">
  <div class="inner-wrapper d-flex flex-column flex-lg-row">
    <div class="scan-right-side flex-fill overflow-lg-auto">
      <div class="h-100 w-100 pb-4">
        @if (selectedStep() !== step.ERROR) {
          <div
            class="header border-bottom drop-shadow pb-4 hw-65 w-100 justify-content-between d-flex align-items-center pt-4 px-4">
            <div class="fs-18 fw-700 text-justify ps-lg-4"><img src="assets/images/icons/FM-logo-green.svg" alt="">
            </div>
            <div class="contact d-none d-lg-flex align-items-center">
              <div class="phone d-flex align-items-center">
                <img class="me-1" src="assets/images/icons/phone.png" height="14px" alt="">
                <p class="fs-12 mb-0" style="color: rgba(106, 106, 106, 1);">
                  <!-- {{doctorInfo().doctor_mobile_country_code}} -->
                </p>
                <!-- <input type="text" [ngModel]="doctorInfo().doctor_mobile" [mask()]="mask()"
                class="pe-none fs-12 fw-500 mxw-140 bg-transparent border-0"
                style="color: rgba(106, 106, 106, 1);"> -->
                <p class="pe-none fs-12 fw-500 mxw-140 bg-transparent mb-0 me-3 border-0">+1 (949) 565-2463</p>
              </div>
              <div class="email d-flex align-items-center">
                <img src="assets/images/icons/email-icon.png" height="14px" alt="">
                <p class="fs-12 fw-500 mb-0 ms-1">
                  <!-- {{doctorInfo().doctor_email}} -->
                  support&#64;financemutual.com
                </p>
              </div>
            </div>
            <!-- <button class="btn d-lg-none" data-bs-toggle="offcanvas" data-bs-target="#contactOffcanvas"> ☰ </button> -->
            <p class="d-lg-none mb-0 text-end px-0" data-bs-toggle="offcanvas" data-bs-target="#contactOffcanvas"><img src="assets/images/icons/contact-here.png" alt=""> </p>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<div class="offcanvas offcanvas-end" tabindex="-1" id="contactOffcanvas">

  <div class="offcanvas-header border-bottom">
    <h5 class="offcanvas-title"><img src="assets/images/icons/FM-logo-green.svg" alt=""></h5>
    <button type="button" class="btn-close" data-bs-dismiss="offcanvas">
    </button>
  </div>

  <div class="offcanvas-body">

    <div class="d-flex align-items-center mb-3">
      <img src="assets/images/icons/phone.png" height="16" class="me-2">
      <span>+1 (949) 565-2463</span>
    </div>

    <div class="d-flex align-items-center">
      <img src="assets/images/icons/email-icon.png" height="16" class="me-2">
      <span>support&#64;financemutual.com</span>
    </div>

  </div>
</div>



@if (selectedStep() === step.VERIFIED) {
  <div class="verified d-flex justify-content-center align-items-center text-center">
    <div class="icon">
      <img class="mb-2" src="assets/images/icons/greenTick.svg" alt="">
      <h3 class="fs-24 fw-800">Your email is verified 🎉</h3>
      <p class="fs-16 fw-500">
        Your email has been successfully verified. <br>
        You’re all set!
      </p>
      <button routerLink="/app/dashboard" class="btn btn-secondary py-3 px-3 fs-16 fw-700">
        Continue to Business Panel
      </button>
    </div>
  </div>
}

@if (selectedStep() === step.LOADING) {
  <div class="loader-wrapper d-flex justify-content-center align-items-center text-center">
    <div class="spinner">
      <img src="assets/images/icons/subtract.png" class="spinner-rotating" alt="Rotating" />
      <img src="assets/images/icons/email-green-icon.png" class="spinner-icon" alt="Icon" />
    </div>
    <h3 class="fs-24 fw-800 text-center mb-0 mt-3">Email Verification</h3>
    <p class="mt-3 fs-16 fw-500 text-secondary text-center">
      We’re verifying your email address. This will only <br> take a moment…
    </p>
  </div>
}

@if (selectedStep() === step.ERROR) {
  <div class="error d-flex justify-content-center align-items-center text-center">
    <div class="icon">
      <img src="assets/images/icons/link_expired.png" class="mb-4 error-img" alt="">
      <h3 class="fs-32 fw-800 ">Email verification link expired</h3>
      <p class="fs-16 fw-500">
        This verification link has expired. Please log in to your <br> Business Panel to request a new one.
      </p>
      <button routerLink="/app/dashboard" class="btn btn-secondary py-3 px-3 fs-16 fw-700">
        Continue to Business Panel
      </button>
    </div>
  </div>
}